(function () {
  let FULLPAGE_INITIALIZED = false;

  /* =========================
   * Viewport Height (mobile safe)
   * ========================= */
  function setVH() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  /* =========================
   * Header Height Sync
   * ========================= */
  function setHeaderHeight() {
    const header =
      document.querySelector('header, .site-header, .header');
    const height = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty(
      '--header-h',
      `${height}px`
    );
  }

  /* =========================
   * Marquee Init (safe)
   * ========================= */
  function initMarquee(marqueeEl) {
    if (!marqueeEl) return;
    if (marqueeEl.classList.contains('marquee-initialized')) return;

    const speed = parseFloat(marqueeEl.dataset.speed) || 120;
    const wrappers = marqueeEl.querySelectorAll('.marquee-smooth__wrapper');
    if (wrappers.length !== 2) return;

    const wrapperA = wrappers[0];
    const wrapperB = wrappers[1];

    wrapperB.innerHTML = '';

    function ensureWidth(wrapper, minWidth) {
      const items = Array.from(wrapper.children);
      let safety = 0;

      while (wrapper.offsetWidth < minWidth && safety < 10) {
        items.forEach(item => {
          wrapper.appendChild(item.cloneNode(true));
        });
        safety++;
      }
    }

    requestAnimationFrame(() => {
      ensureWidth(wrapperA, marqueeEl.offsetWidth * 2);
      wrapperB.innerHTML = wrapperA.innerHTML;

      const width = wrapperA.offsetWidth;
      if (!width) return;

      const duration = width / speed;

      wrappers.forEach((wrapper, index) => {
        wrapper.style.animation = 'none';
        void wrapper.offsetHeight;

        wrapper.style.animationName = 'marquee-slide-scroll';
        wrapper.style.animationTimingFunction = 'linear';
        wrapper.style.animationIterationCount = 'infinite';
        wrapper.style.animationDuration = `${duration}s`;
        wrapper.style.animationDelay =
          index === 1 ? `${-duration}s` : '0s';
      });

      marqueeEl.classList.add('marquee-initialized');
    });
  }

  /* =========================
   * fullPage Init (ONLY ONCE)
   * ========================= */
  function initFullpageOnce() {
    if (FULLPAGE_INITIALIZED) return;

    const sectionEl = document.querySelector('[data-fullpage]');
    if (!sectionEl) return;

    const sections = sectionEl.querySelectorAll('.section');
    if (!sections.length) return;

    FULLPAGE_INITIALIZED = true;

    const anchors = Array.from(sections).map(
      (_, i) => `slide${i + 1}`
    );

    if (window.AOS && !window.__AOS_INIT__) {
      AOS.init({
        duration: 1000,
        once: false,
        disable: false
      });
      window.__AOS_INIT__ = true;
    }

    new fullpage(`#${sectionEl.id}`, {
      autoScrolling: true,
      fitToSection: true,
      scrollingSpeed: 900,
      navigation: false,
      anchors,
      scrollOverflow: false,

      afterLoad(origin, destination) {
        const isLast =
          destination.index === sections.length - 1;

        document.body.classList.toggle('show-footer', isLast);

        destination.item
          .querySelectorAll('[data-aos]')
          .forEach(el => el.classList.add('aos-animate'));

        destination.item
          .querySelectorAll('.marquee-smooth')
          .forEach(initMarquee);
      },

      afterRender() {
        const first = sections[0];

        first
          .querySelectorAll('[data-aos]')
          .forEach(el => el.classList.add('aos-animate'));

        first
          .querySelectorAll('.marquee-smooth')
          .forEach(initMarquee);
      }
    });
  }

  /* =========================
   * Initial Load
   * ========================= */
  document.addEventListener('DOMContentLoaded', () => {
    setVH();
    setHeaderHeight();
    initFullpageOnce();
  });

  /* =========================
   * Resize / Orientation
   * ========================= */
  window.addEventListener('resize', () => {
    setVH();
    setHeaderHeight();
  });

  window.addEventListener('orientationchange', () => {
    setVH();
    setHeaderHeight();
  });

  /* =========================
   * Shopify Theme Editor (SAFE)
   * ========================= */
  document.addEventListener('shopify:section:load', e => {
    e.target
      .querySelectorAll('.marquee-smooth')
      .forEach(initMarquee);
  });
})();
